/** JSON: экспорт payload, импорт (наш формат, Discord API, Discohook), загрузка сообщения по ссылке. */
import { draftToPayload, importAnyJson } from '../../../src/shared/convert.js';
import { api } from '../api.js';
import { app } from '../ctx.js';
import { h, icon } from '../dom.js';
import { store } from '../store.js';
import { pickFile } from '../ui/inputs.js';
import { modal, toast } from '../ui/overlay.js';
import { segmented } from './common.js';

function download(name: string, text: string) {
  const url = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
  const a = h('a', { href: url, download: name });
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function openJsonModal(initialTab: 'export' | 'import' | 'link' = 'export') {
  const m = modal({ title: 'JSON и импорт', icon: 'code', wide: true });
  let tab = initialTab;
  let format: 'api' | 'draft' = 'api';
  const body = h('div', { class: 'json-body' });

  const render = () => {
    body.replaceChildren(
      segmented(
        [
          { value: 'export', label: 'Экспорт', icon: 'download' },
          { value: 'import', label: 'Импорт', icon: 'upload' },
          { value: 'link', label: 'По ссылке', icon: 'link' },
        ],
        tab,
        (v) => {
          tab = v as typeof tab;
          render();
        },
      ),
    );
    if (tab === 'export') {
      const text = format === 'api' ? JSON.stringify(draftToPayload(store.draft, { target: 'bot' }).body, null, 2) : JSON.stringify(store.draft, null, 2);
      const area = h('textarea', { class: 'input textarea mono code-area', value: text, readOnly: true, rows: 18, spellcheck: false, attrs: { 'aria-label': 'JSON' } });
      body.append(
        segmented(
          [
            { value: 'api', label: 'Discord API payload' },
            { value: 'draft', label: 'Черновик Embed Studio' },
          ],
          format,
          (v) => {
            format = v as typeof format;
            render();
          },
        ),
        h('p', { class: 'muted small' }, format === 'api' ? 'Готовое тело запроса для POST /channels/{id}/messages или вебхука.' : 'Полный черновик с действиями кнопок - его можно импортировать обратно без потерь.'),
        area,
        h(
          'div',
          { class: 'btn-row' },
          h(
            'button',
            {
              class: 'btn',
              type: 'button',
              onclick: async () => {
                try {
                  await navigator.clipboard.writeText(text);
                  toast('Скопировано', 'ok');
                } catch {
                  area.select();
                  toast('Буфер обмена недоступен - текст выделен, нажмите Ctrl+C', 'info');
                }
              },
            },
            icon('copy', 16),
            'Копировать',
          ),
          h('button', { class: 'btn', type: 'button', onclick: () => download(format === 'api' ? 'message.json' : 'draft.json', text) }, icon('download', 16), 'Скачать'),
        ),
      );
    } else if (tab === 'import') {
      const area = h('textarea', { class: 'input textarea mono code-area', rows: 16, spellcheck: false, placeholder: '{ "content": "...", "embeds": [...], "components": [...] }', attrs: { 'aria-label': 'JSON для импорта' } });
      const doImport = (text: string) => {
        try {
          const res = importAnyJson(JSON.parse(text));
          store.replace(res.draft, { editTarget: null, templateId: null, templateName: null });
          toast(res.warnings.length ? `Импортировано с замечаниями: ${res.warnings[0]}` : 'Импортировано', res.warnings.length ? 'info' : 'ok');
          m.close();
        } catch (err: any) {
          toast(`Не удалось импортировать: ${err.message}`, 'error');
        }
      };
      body.append(
        h('p', { class: 'muted small' }, 'Подходит JSON из Discord API, бэкап Discohook, черновик Embed Studio или payload из других конструкторов.'),
        area,
        h(
          'div',
          { class: 'btn-row' },
          h('button', { class: 'btn btn-primary', type: 'button', onclick: () => doImport(area.value) }, icon('upload', 16), 'Импортировать'),
          h(
            'button',
            {
              class: 'btn',
              type: 'button',
              onclick: async () => {
                const [f] = await pickFile('.json,application/json');
                if (f) doImport(await f.text());
              },
            },
            icon('file', 16),
            'Из файла',
          ),
        ),
      );
    } else {
      const input = h('input', { class: 'input', placeholder: 'https://discord.com/channels/...', attrs: { 'aria-label': 'Ссылка на сообщение' } });
      const btn = h(
        'button',
        {
          class: 'btn btn-primary',
          type: 'button',
          onclick: async () => {
            btn.disabled = true;
            try {
              const res = await api.loadMessage(app.guild!.id, input.value);
              store.replace(res.draft, { editTarget: res.editTarget, templateId: null, templateName: null });
              toast(res.editTarget ? 'Загружено - изменения можно сохранить в исходное сообщение' : 'Загружено как копия', 'ok');
              for (const w of res.warnings.slice(0, 2)) toast(w, 'info');
              m.close();
            } catch (err: any) {
              toast(err.message, 'error');
            } finally {
              btn.disabled = false;
            }
          },
        },
        icon('download', 16),
        'Загрузить',
      );
      body.append(
        h('p', { class: 'muted small' }, 'Загрузит сообщение с этого сервера в редактор. Сообщения бота можно будет сразу отредактировать на месте. Быстрее всего - ПКМ по сообщению -> Приложения -> «Спарсить».'),
        h('div', { class: 'input-group' }, input, btn),
      );
    }
  };
  render();
  m.body.append(body);
}
